import { type RouteObject, createBrowserRouter } from "react-router";
import { AppShell } from "./components/AppShell";
import CalculatorPage from "./routes/Calculator";
import ComparePage from "./routes/Compare";
import PrivacyPage from "./routes/Privacy";
import SavedPage from "./routes/Saved";
import SettingsPage from "./routes/Settings";
import TermsPage from "./routes/Terms";

export const routes: RouteObject[] = [
  {
    element: <AppShell />,
    children: [
      { index: true, element: <CalculatorPage /> },
      { path: "compare", element: <ComparePage /> },
      { path: "saved", element: <SavedPage /> },
      { path: "settings", element: <SettingsPage /> },
      { path: "terms", element: <TermsPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "*", element: <CalculatorPage /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
